<template>
  <div v-if="isShow" class="bg_white">
    <div v-if="!complete" class="edit_bank">
      <AccountRadio v-if="!confirmYucho && !confirmOtherYucho" :bankAccount="bankData.bankAccount" @changeRadio="recieveChangeRadio" />
      <Yucho v-if="bankData.bankAccount.postOffice" :bankAccount="bankData.bankAccount" :confirm="confirmYucho" :error="error.yucho" />
      <OtherYucho ref="otherYucho" v-else :watchStatus="watchStatus" :bankAccount="bankData.bankAccount" :confirm="confirmOtherYucho" :error="error.otherYucho" />
      <Message :bankData="bankData" :confirm="[confirmYucho, confirmOtherYucho]" />
      <div class="btn_wrap bg_white">
        <button v-if="!confirmYucho && !confirmOtherYucho" @click="checkForm()" type="button" name="button" class="btn btn_blue next">次へ</button>
        <div v-else class="">
          <button @click="editComplete()" type="button" name="button" class="btn btn_blue">確定</button>
          <div class="mt16">
            <button @click="back()" type="button" name="button" class="btn btn_delete next">戻る</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="bg_white pt25 pl15 ab c5a">{{ completeMessage }}</div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken'
import AccountRadio from '@/components/bank/Radio';
import OtherYucho from '@/components/bank/OtherYucho';
import Yucho from '@/components/bank/Yucho';
import Message from '@/components/bank/Message';
import BankApi from '@/components/api/bankAccount';

export default {
  components: {
    AccountRadio,
    Yucho,
    OtherYucho,
    Message
  },
  data() {
    return {
      isShow: true,
      watchStatus: null,
      bankData: {
        // ゆうちょ銀行以外の場合
        bankAccount: {
          accountName: null,
          accountNumber: null,
          accountType: null,
          bank: {
            bankCode: null,
            bankId: null,
            bankName: null,
            bankNameKana: null
          },
          branch: {
            branchCode: null,
            branchId: null,
            branchName: null,
            branchNameKana: null
          },
          // ゆうちょ銀行の場合
          postOffice: false,
          postOfficeNumber: null,
          postOfficeSign: null
        },
        transferRequest: false
      },
      error: {
        yucho: {
          postOfficeNumber: '',
          postOfficeSign: ''
        },
        otherYucho: {
          // accountName: '',
          accountNumber: '',
          accountType: '',
          bankName: '',
          branchName: '',
        }
      },
      confirmYucho: false,
      confirmOtherYucho: false,
      complete: false,
      completeMessage: '',
    }
  },
  methods: {
    setBankData(data) {
      this.bankData.bankAccount.accountName = (data.bankAccount.accountName) ? data.bankAccount.accountName : '';
      this.bankData.bankAccount.accountNumber = (data.bankAccount.accountNumber) ? data.bankAccount.accountNumber : '';
      this.bankData.bankAccount.accountType = (data.bankAccount.accountType) ? data.bankAccount.accountType : 'SAVING';
      this.bankData.bankAccount.bank.bankCode = (data.bankAccount.bank.bankCode) ? data.bankAccount.bank.bankCode : '';
      this.bankData.bankAccount.bank.bankId = (data.bankAccount.bank.bankId) ? data.bankAccount.bank.bankId : '';
      this.bankData.bankAccount.bank.bankName = (data.bankAccount.bank.bankName) ? data.bankAccount.bank.bankName : '';
      this.bankData.bankAccount.bank.bankNameKana = (data.bankAccount.bank.bankNameKana) ? data.bankAccount.bank.bankNameKana : '';
      this.bankData.bankAccount.branch.branchCode = (data.bankAccount.branch.branchCode) ? data.bankAccount.branch.branchCode : '';
      this.bankData.bankAccount.branch.branchId = (data.bankAccount.branch.branchId) ? data.bankAccount.branch.branchId : '';
      this.bankData.bankAccount.branch.branchName = (data.bankAccount.branch.branchName) ? data.bankAccount.branch.branchName : '';
      this.bankData.bankAccount.branch.branchNameKana = (data.bankAccount.branch.branchNameKana) ? data.bankAccount.branch.branchNameKana : '';
      this.bankData.bankAccount.postOffice = data.bankAccount.postOffice;
      this.bankData.bankAccount.postOfficeNumber = (data.bankAccount.postOfficeNumber) ? data.bankAccount.postOfficeNumber : '';
      this.bankData.bankAccount.postOfficeSign = (data.bankAccount.postOfficeSign) ? data.bankAccount.postOfficeSign : '';
    },
    checkForm() {
      let res; // trueなら遷移しない
      console.log(this.bankData.bankAccount.postOffice);
      this.bankData.bankAccount.postOffice ? res = this.checkYucho() : res = this.checkOtherYucho();
      if(res) {
        console.log('error');
        return true;
      }
      console.log('送信');
    },
    checkYucho() {
      console.log('Yucho');
      this.error.yucho.postOfficeNumber = '';
      this.error.yucho.postOfficeSign = '';
      let error = false;
      if(!this.bankData.bankAccount.postOfficeNumber) {
        this.error.yucho.postOfficeNumber = '通帳記号は必須です。';
        error = true;
      }
      if(!this.bankData.bankAccount.postOfficeSign) {
        this.error.yucho.postOfficeSign = '通帳番号は必須です。';
        error = true;
      }
      error ? '' : this.confirmYucho = true;
      return error;
    },
    checkOtherYucho() {
      console.log('OtherYucho');
      this.error.otherYucho.accountName = '';
      this.error.otherYucho.accountNumber = '';
      this.error.otherYucho.accountType = '';
      this.error.otherYucho.bankName = '';
      this.error.otherYucho.branchName = '';
      let error = false;
      if(!this.bankData.bankAccount.accountNumber) {
        this.error.otherYucho.accountNumber = '口座番号は必須です。';
        error = true;
      } else if(!/[0-9]{7}/.test(this.bankData.bankAccount.accountNumber)) {
        this.error.otherYucho.accountNumber = '口座番号は7桁で入力してください。<br>7桁未満の場合は、頭に0を入力してください。';
        error = true;
      }
      if(!this.bankData.bankAccount.accountType) {
        this.error.otherYucho.accountType = '口座種別は必須です。';
        error = true;
      }
      if(this.bankData.bankAccount.bank.bankName == '' || this.bankData.bankAccount.bank.bankId == '') {
        this.error.otherYucho.bankName = '銀行名は必須です。';
        error = true;
      }
      if(this.bankData.bankAccount.branch.branchName == '' || this.bankData.bankAccount.branch.branchId == '') {
        this.error.otherYucho.branchName = '支店名は必須です。';
        error = true;
      }

      error ? '' : this.confirmOtherYucho = true;
      return error;
    },
    back() {
      this.confirmYucho = false;
      this.confirmOtherYucho = false;
    },
    editComplete() {
      if(this.confirmYucho) {
        // ゆうちょ = 以外の場;
        this.bankData.bankAccount.accountName = '';
        this.bankData.bankAccount.accountNumber = '';
        this.bankData.bankAccount.accountType = null;
        this.bankData.bankAccount.bank.bankCode = '';
        this.bankData.bankAccount.bank.bankId = null;
        this.bankData.bankAccount.bank.bankName = '';
        this.bankData.bankAccount.bank.bankNameKana = '';
        this.bankData.bankAccount.branch.branchCode = '';
        this.bankData.bankAccount.branch.branchId = '';
        this.bankData.bankAccount.branch.branchName = null;
        this.bankData.bankAccount.branch.branchNameKana = '';
      }else {
        this.bankData.bankAccount.postOfficeNumber = '';
        this.bankData.bankAccount.postOfficeSign = '';
        this.bankData.bankAccount.postOffice = false;
      }
      this.apiUpdateBankAccount();
    },

    async apiGetBankAccount() {
      console.log('apiGetBankAccount');
      await BankApi.getBankAccount().then((val) => {
        // this.apiUpdateBankAccount(val).then((value) => {
        //   console.log(value);
        // });
        console.log(val);
        console.log('通帳記号 '+val.bankAccount.postOfficeSign);
        console.log('通帳番号 '+val.bankAccount.postOfficeNumber);
        this.setBankData(val);
        // otherYuchoコンポーネントのautoCompleteDefaultData()メソッドを実行
        // this.$refs.otherYucho.autoCompleteDefaultData();
      });
    },
    async apiUpdateBankAccount() {
      await BankApi.updateBankAccount(this.bankData).then((val) => {
        // console.log(val);
        if(val.status == 'OK') {
          if(this.$route.query.redirect_url) {
            this.$router.push({ name: this.$route.query.redirect_url });
          } else {
            this.completeMessage = '口座情報の編集が完了しました。';
          }
        } else {
          this.completeMessage = '口座情報の編集に失敗しました。';
        }
        this.complete = true;
      });
    },
    recieveChangeRadio(data) {
      console.log(data);
      this.watchStatus = data;
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.apiGetBankAccount();
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.btn_wrap {
  padding: 50px 0 120px;
}
>>> .error {
  color: red;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/member/EditBankAccount.vue